export const SET_ADD_ELEMENTS_PENDING = "SET_ADD_ELEMENTS_PENDING";
export const SET_ADD_ELEMENTS = "SET_ADD_ELEMENTS";
export const SET_PLC_CURRENTFIELD = "SET_PLC_CURRENTFIELD";
export const SET_PLC_FILTER_VALUES = "SET_PLC_FILTER_VALUES";
export const SET_INLET_FIELD = "SET_INLET_FIELD";
export const SET_ADDPIPE_PENDING = "SET_ADDPIPE_PENDING";
export const OPEN_DELETE_PIPE_MODAL = "OPEN_DELETE_PIPE_MODAL";
export const CLOSE_DELETE_PIPE_MODAL = "CLOSE_DELETE_PIPE_MODAL";
export const SET_PIPES_PENDING = "SET_PIPES_PENDING";
export const SET_PIPES = "SET_PIPES";
export const OPEN_CONSULT_PIPE_MODAL = "OPEN_CONSULT_PIPE_MODAL";
export const CLOSE_CONSULT_PIPE_MODAL = "CLOSE_CONSULT_PIPE_MODAL";
export const SET_CONSULTPIPES_PENDING = "SET_CONSULTPIPES_PENDING";
export const SET_CONSULT_PIPE = "SET_CONSULT_PIPE";
export const SET_DELETE_PIPE_PENDING = "SET_DELETE_PIPE_PENDING";
export const SET_CLEAR_PIPES_PENDING = "SET_CLEAR_PIPES_PENDING";
export const SET_COMPUTEPD_PENDING = "SET_COMPUTEPD_PENDING";
export const SET_COMPUTEPD = "SET_COMPUTEPD";
export const SET_CLOSE_WINDOW_PENDING = "SET_CLOSE_WINDOW_PENDING";
export const SET_CLOSE_WINDOW = "SET_CLOSE_WINDOW";
export const SET_CLOSE_REDIRECT = "SET_CLOSE_REDIRECT";
export const CONSULT_PIPE_DISABLE = "CONSULT_PIPE_DISABLE";
export const SET_OUTLET_FIELD = "SET_OUTLET_FIELD";
export const SET_COMPUTEPD_OUTLET = "SET_COMPUTEPD_OUTLET";
export const OPEN_NONNEWTONIAN_MODEL = "OPEN_NONNEWTONIAN_MODEL";
export const CLOSE_NONNEWTONIAN_MODEL = "CLOSE_NONNEWTONIAN_MODEL";
export const SET_NONNEWTONIAN_VALUES = "SET_NONNEWTONIAN_VALUES";
export const SET_ERROR_REDIRECT = "SET_ERROR_REDIRECT";
export const OPEN_LIQUID_GRAPH_MODAL = "OPEN_LIQUID_GRAPH_MODAL";
export const SORT_COORDINATES_PENDING = "SORT_COORDINATES_PENDING";
export const CLOSE_LIQUID_GRAPH_MODAL = "CLOSE_LIQUID_GRAPH_MODAL";
export const VALIDATE_GRAPH_PENDING = "VALIDATE_GRAPH_PENDING";
export const SET_IMAGINARY_LINE = "SET_IMAGINARY_LINE";